import { MultiLangText } from "src/utils/types"
import { Taluka } from "../../entities/taluka"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	name: MultiLangText
	sameAsParent?: boolean
	districtId: string
}

export async function talukaAddApi(payload: RequestDataShape, token: string) {
	const endpoint = "/taluka/add/v1"
	const requester = new ApiRequester<RequestDataShape, Taluka>(endpoint)
	return await requester.sendRequest(payload, token)
}
